import { render, staticRenderFns } from "./RideSmartAndSafe.vue?vue&type=template&id=35dbb4f4&scoped=true"
import script from "./RideSmartAndSafe.vue?vue&type=script&lang=js"
export * from "./RideSmartAndSafe.vue?vue&type=script&lang=js"
import style0 from "./RideSmartAndSafe.vue?vue&type=style&index=0&id=35dbb4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dbb4f4",
  null
  
)

export default component.exports